import type { GuideRef } from '../types'

export interface StoryboardReferenceImage {
  image_url: string
}

function isWasabiUrl(url?: string): boolean {
  return !!url && /wasabisys\.com/i.test(url)
}

/** Submit URL for reference_images — S3 only, consistent with other image flows. */
function resolveS3ImageUrl(ref: GuideRef): string {
  const candidates = [ref.imageUrl, ref.thumbnailUrl, ref.url]
  for (const url of candidates) {
    if (!url || url.startsWith('blob:') || isWasabiUrl(url)) continue
    return url
  }
  return ''
}

export function buildReferenceImageFromGuideRef(
  ref: GuideRef
): StoryboardReferenceImage | null {
  if (ref.status === 'uploading' || ref.status === 'error') return null

  const image_url = resolveS3ImageUrl(ref)
  if (!image_url) return null

  return { image_url }
}

export function buildReferenceImagesFromGuideRefs(
  refs: (GuideRef | null)[]
): StoryboardReferenceImage[] {
  return refs
    .filter((ref): ref is GuideRef => Boolean(ref))
    .map(buildReferenceImageFromGuideRef)
    .filter((item): item is StoryboardReferenceImage => Boolean(item))
}
